import { createContext, useContext } from 'react';
import { StoreApi, useStore } from 'zustand';
import { VideoStore } from '../videoStore';

export const VideoStoreContext = createContext<StoreApi<VideoStore> | null>(
  null
);

export function useVideoStore<T>(selector: (state: VideoStore) => T) {
  const store = useContext(VideoStoreContext);

  if (!store) {
    throw new Error('Missing VideoStore provider');
  }

  return useStore(store, selector);
}
